import type { BillingInterval, Currency } from '@sine/sine-core-api-types';
import type { ISelectOption } from '@sine/sine-ui-components';

export const FOURTEEN_DAYS_IN_MILLISECONDS = 12096e5;

export const currencyList: Record<Currency, ISelectOption> = {
  usd: { label: 'USD', value: 'usd' },
  aud: { label: 'AUD', value: 'aud' },
  nzd: { label: 'NZD', value: 'nzd' },
  gbp: { label: 'GBP', value: 'gbp' },
};

export const allCurrencyOptions: Array<ISelectOption> = Object.values(currencyList);

export const BillingIntervalValues = {
  YEARLY: 'year',
  MONTHLY: 'month',
  DAILY: 'day',
} as const satisfies Record<string, BillingInterval>;
